
import { Component, Vue, Watch } from 'vue-property-decorator';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Top from '@/components/Top.vue';
import Bottom from '@/components/Bottom.vue';
import TopBg from '@/components/TopBg.vue';
import { Api } from '../utils/request';
import date from '@/utils/date';
import Bar from '@/components/Bar.vue';
import ContentType from '../interfaces/content-type';
import MokYun from '@/components/MokYun.vue';
Vue.use(ElementUI);
@Component({
  components: {
    MokYun,
    Top,
    Bottom,
    TopBg,
    Bar,
  },
})
export default class Mokyun extends Vue {
  public menuList: any = [];
  public selectMenu: any = [];
  public selectId = 0;
  public parentId = 0;
  public selectTitle = '';
  public parentTitle = '';
  public configInfo: any = [];
  public list: any = [];
  public page = 1;
  public pageNum = 0;
  public empty = false;
  public jumpType = 0;
  public info = {};
  public infoShow = true;
  @Watch('$route')
  async routechange(to: any, from: any) {
    if (to.query != from.query) {
      this.empty = false;
      await this.getValue();
      await this.getPageNum();
      await this.getList();
    }
  }

  async mounted() {
    this.list = [];
    await this.getValue();
    await this.getList();
    if (
      this.jumpType === ContentType.File ||
      this.jumpType === ContentType.Company ||
      this.jumpType === ContentType.Download
    ) {
      await this.getPageNum();
    }
    localStorage.setItem('type', JSON.stringify(this.jumpType));
  }
  async getValue() {
    const res: any = localStorage.getItem('config');
    this.configInfo = JSON.parse(res);
    const res2: any = localStorage.getItem('menuList');
    this.menuList = JSON.parse(res2);
    this.selectId = Number(this.$route.query.id);
    this.parentId = Number(this.$route.query.parentId);
    this.jumpType = Number(this.$route.query.type);
    if (this.jumpType !== ContentType.Download && this.parentId > 0) {
      const res = await Api.Menus.getAsideMenu({ id: this.parentId });
      res.child.map((v: any) => {
        if (v.id === this.selectId) {
          this.selectTitle = v.title;
        }
      });
      this.parentTitle = res.title;
      this.selectMenu = res;
    }
    if (this.jumpType === ContentType.Download) {
      this.parentTitle = '资料下载';
      this.selectTitle = '下载中心';
    }
    if (!this.parentId && this.jumpType === ContentType.Text) {
      const res = await Api.Project.getInfo({ menuId: this.selectId });
      const sliderMenu = await Api.Menus.getSliderMenu();
      sliderMenu.map((v: any) => {
        if (res.menuId === v.id) {
          this.selectTitle = v.title;
        }
      });
    }
    if (!this.parentTitle) {
      this.parentTitle = String(this.$route.query.title);
    }
    if (!this.selectTitle) {
      this.selectTitle = String(this.$route.query.title);
    }
  }
  async getList() {
    this.list = [];
    this.info = {};
    if (this.jumpType === ContentType.Text) {
      this.infoShow = true;
      this.info = (await Api.Project.getInfo({ menuId: this.selectId })) || {};
      return;
    }
    if (this.jumpType === ContentType.Company) {
      this.infoShow = false;
      this.list = await Api.Company.getList({
        limit: 10,
        page: this.page,
        indexStatus: false,
      });
      this.list.map((v: any) => {
        v.uploadTime = date(v.uploadTime);
      });
      return;
    }
    if (this.jumpType === ContentType.Download) {
      this.infoShow = false;
      this.list = await Api.Download.getList({
        limit: 10,
        page: this.page,
        indexStatus: false,
      });
      this.list.map((v: any) => {
        v.uploadTime = date(v.uploadTime);
      });
      return;
    }
    this.infoShow = false;
    this.list =
      (await Api.Article.getList({
        page: this.page,
        limit: 10,
        menuId: this.selectId,
        indexStatus: false,
      })) || [];
    this.list.map((v: any) => {
      v.uploadTime = date(v.uploadTime);
    });
  }
  async getPageNum() {
    let res = [];
    if (this.jumpType === ContentType.File) {
      res = await Api.Article.getPageNum({
        menuId: this.selectId,
      });
    }
    if (this.jumpType === ContentType.Company) {
      res = await Api.Company.getPageNum();
    }
    if (this.jumpType === ContentType.Download) {
      res = await Api.Download.getPageNum();
    }
    if (res === '暂无') {
      return (this.empty = true);
    }
    this.empty = false;
    this.pageNum = res;
  }
  async changeList(val: any) {
    this.page = val;
    await this.getList();
  }
  async lastList() {
    this.page = this.page - 1;
    await this.getList();
  }
  async nextList() {
    this.page = this.page + 1;
    await this.getList();
  }
  // goInfo(id: any) {
  //   const type: any = this.jumpType;
  //   const routeUrl = this.$router.resolve({
  //     name: 'Content',
  //     path: '/content',
  //     query: { id, type },
  //   });
  //   window.open(routeUrl.href, '_blank');
  //   scrollTo(0, 0);
  // }

  goInfo(id: any) {
    const type: any = this.jumpType;
    this.$router.push({
      name: 'Content',
      path: '/content',
      query: { id, type },
    });

    scrollTo(0, 0);
  }
  goOther(id: any, parentId: any, jumpType: any) {
    this.$router.push({
      path: '/list',
      query: {
        id,
        parentId,
        type: jumpType,
      },
    });
    scrollTo(0, 0);
  }
}
